import * as React from 'react';

import { AUTHENTICATION_MODAL_MODES } from 'bundles/authentication/constants';
import { OrganizationSSO } from 'bundles/authentication/shared/components/authentication-modal/OrganizationSSO/OrganizationSSO';
import type { Props } from 'bundles/authentication/shared/components/authentication-modal/OrganizationSSO/types';

const LoginComponent = (props: Props) => (
  <OrganizationSSO {...props} ssoMode={AUTHENTICATION_MODAL_MODES.ORGANIZATIONLOGIN} />
);

export default LoginComponent;
